export default __webpack_public_path__ + "static/wsl-meshery-complete-61bcfec5af90792f821e7533504db6de.webp";